<template>
  <div>
    <card class="card-stats" :show-footer-line="true">
      <p class="mt-3 mb-0 text-sm">
        <slot>
          <b-row v-if="contractId" class="space">
            <b-col md="5">
              <i :class="contractIcon" class="iconPadding"></i>
              <span><strong> Гэрээний дугаар </strong></span>
            </b-col>
            <b-col md="4">
              <span
                ><strong>{{ contractId }}</strong></span
              >
            </b-col>
          </b-row>
          <b-row
            v-if="phoneNumbers"
            class="space"
            v-show="phoneNumbers != null && phoneNumbers.length > 0"
          >
            <b-col md="5">
              <i :class="phoneIcon" class="iconPadding"></i>
              <span><strong> Утасны дугаар </strong></span>
            </b-col>
            <b-col md="2">
              <d-form-select
                size="sm"
                v-model="defualtOption"
                @change="onChange($event)"
              >
                <option
                  v-for="item in phoneNumbers"
                  :value="item"
                  :key="item.phone"
                >
                  {{ item.phone }}
                </option>
              </d-form-select>
            </b-col>
          </b-row>
          <b-row v-if="packageType" class="space">
            <b-col md="5">
              <i :class="packageIcon" class="iconPadding"></i>
              <span><strong> Үйлчилгээний багц </strong></span>
            </b-col>
            <b-col md="4">
              <span
                ><strong>{{ packageType }}</strong></span
              >
            </b-col>
          </b-row>
          <b-row v-if="billDate" class="space">
            <b-col md="5">
              <i :class="billIcon" class="iconPadding"></i>
              <span><strong> Билл цикл огноо </strong></span>
            </b-col>
            <b-col md="5">
              <span
                ><strong>{{ billDate }}</strong></span
              >
            </b-col>
          </b-row>
          <b-row class="space">
            <b-col md="5">
              <i :class="emailIcon" class="iconPadding"></i>
              <span><strong> И-мэйл хаяг </strong></span>
            </b-col>
            <b-col md="2">
              <span v-if="!toggleEmail"
                ><strong>{{ email }}</strong></span
              >
              <b-input
                id="emailRef"
                ref="emailRef"
                v-if="toggleEmail"
                type="email"
                :disabled="!toggleEmail"
                size="sm"
                v-model.trim="$v.email.$model"
                placeholder="Шинэ и-мэйл оруулна уу"
                :class="{
                  'is-invalid': $v.email.$error,
                  'is-valid': !$v.email.$invalid,
                }"
              ></b-input>
              <div class="valid-feedback"></div>
              <div class="invalid-feedback">
                <span v-if="!$v.email.required">И-мэйл оруулна уу.</span>
              </div>
            </b-col>
            <b-col md="3">
              <a
                href="#"
                v-if="!toggleEmail"
                class="btn btn-sm btn-outline-info"
                @click="changeEmail"
                >Солих</a
              >
              <a
                href="#"
                v-if="toggleEmail"
                class="btn btn-sm btn-outline-success"
                @click="saveEmail"
                >Хадгалах</a
              >
            </b-col>
          </b-row>
          <b-row class="space">
            <b-col md="5">
              <i :class="passIcon" class="iconPadding"></i>
              <span><strong> Нууц үг </strong></span>
            </b-col>
            <b-col md="2">
                <span v-if="!changePass"
                ><strong>**********</strong></span
              >
              <b-input
                ref="passwordRef"
                id="password"
                type="password"
                 v-if="changePass"
                :disabled="!changePass"
                size="sm"
                v-model.trim="$v.password.$model"
                placeholder="Нууц үг оруулна уу"
                :class="{
                  'is-invalid': $v.password.$error,
                  'is-valid': !$v.password.$invalid,
                }"
              ></b-input>
              <div class="valid-feedback"></div>
              <div class="invalid-feedback">
                <span v-if="!$v.password.required">Нууц үг оруулна уу.</span>
              </div>
            </b-col>
            <b-col md="3">
              <a
                v-show="!changePass"
                href="#"
                class="btn btn-sm btn-outline-info"
                @click="changePassword"
                >Солих</a
              >
              <a
                v-show="changePass"
                href="#"
                class="btn btn-sm btn-outline-success"
                @click="savePassword"
                >Хадгалах</a
              >
            </b-col>
          </b-row>
        </slot>
      </p>

      <p class="mt-3 mb-0 text-sm">
        <slot name="footer"> </slot>
      </p>
    </card>
    <Toast position="bottom-center" />
  </div>
</template>
<script>
import axios from "axios";
import Card from "./Card.vue";
import Toast from "primevue/toast";
import { required } from "vuelidate/lib/validators";

export default {
  name: "stats-card",
  components: {
    Card,
    Toast,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    icon: String,
    phoneIcon: String,
    phoneNumbers: Array,
    selected: Object,
    packageIcon: String,
    packageType: String,
    contractIcon: String,
    contractId: Number,
    billIcon: String,
    billDate: String,
    emailIcon: String,
    email: String,
    passIcon: String,
    title: String,
    subTitle: String,
    body: String,
    iconClasses: [String, Array],
  },
  data() {
    return {
      selectedOption: JSON.parse(this.selected),
      openModal: false,
      toggleEmail: false,
      changePass: false,
      password: "*******",
    };
  },
  validations: {
    password: {
      required,
    },
    email: {
      required,
    },
  },
  methods: {
    changeEmail() {
      this.toggleEmail = true;
      this.$nextTick(() => {
        const emailInputRef = this.$refs.emailRef;
        emailInputRef.focus();
      });
    },
    changePassword() {
      this.changePass = true;
      this.$nextTick(() => {
        const passwordInputRef = this.$refs.passwordRef;
        passwordInputRef.focus();
      });
    },
    async savePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var config = {
          method: "post",
          url:
            "https://mongolsat.mn/isat/contract/password?username=" +
            this.contractId +
            "" +
            "&password=" +
            this.password +
            "",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.userToken,
          },
        };
        await axios(config)
          .then((response) => {
            if (response != null) {
              this.$toast.add({
                severity: "success",
                summary: "Шинэ нууц үгийг амжилттай шинэчиллээ!",
                detail: "",
                life: 3000,
              });
              this.changePass = false;
            }
          })
          .catch((error) => console.log(error.response));
      }
    },
    async saveEmail() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var config = {
          method: "post",
          url:
            "https://mongolsat.mn/isat/contract/email?username=" +
            this.contractId +
            "" +
            "&email=" +
            this.email +
            "",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.userToken,
          },
        };
        await axios(config)
          .then((response) => {
            if (response != null) {
              this.$toast.add({
                severity: "success",
                summary: "Шинэ и-мэйл амжилттай шинэчиллээ!",
                detail: "",
                life: 3000,
              });
              this.toggleEmail = false;
            }
          })
          .catch((error) => console.log(error.response));
      }
    },
    onChange(event) {
      // set selected index
      this.$store.dispatch("retrieveSelected", {
        selected: event,
      });
      // event currenct number balance
      this.$store.dispatch("retrieveBalance", {
        balance: event.balance,
      });
    },
  },
  computed: {
    defualtOption() {
      return this.selectedOption == null
        ? this.$store.getters.selected
        : this.selectedOption;
    },
  },
};
</script>
<style lang="scss" scoped>
.space {
  margin: 10px;
}
.iconPadding {
  padding: 5px;
}
</style>
